import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { awaitPendingAction, clearPendingAction } from '../actions/pending';
import { omit } from '../utils/object';

export default handleActions({
  [awaitPendingAction]: (state, { payload: { id, promise } }) => ({
    ...state,
    [id]: promise
  }),
  [clearPendingAction]: (state, { payload }) => omit([payload], state)
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/pending-actions.js